import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

const DummyData = [
  {
    pk:"D|600a0c2a69e609aa",
    sk:1712225547992,
    deviceId:"600a0c2a69e609aa",
    device_status:false,
    firmware_device:"imp006",
    installation_date:"2024-04-04T09:10:28.582Z",
    manufacturer_device:"imp006",
    tenant_assignment:"ha52fyuq",
    updated_date:"2024-04-04T09:10:28.582Z"
  },
  {
    pk:"D|600a0c2a69e6092c",
    sk:1712225483377,
    deviceId:"600a0c2a69e6092c",
    device_status:false,
    firmware_device:"imp006",
    installation_date:"2024-03-29T07:58:22.514Z",
    manufacturer_device:"imp006",
    tenant_assignment:"ha52fyuq",
    updated_date:"2024-03-29T07:58:22.514Z"
  },
]
interface InitialState {
    deviceHistoryList: any;
    deviceVersionList: any;
    listLoading: boolean;
    addLoading: boolean;
  }
  const initialState: InitialState = {    
    listLoading: false,
    addLoading: false,
    deviceHistoryList:[],    
    deviceVersionList:[],    
  };
  const deviceHistorySlice = createSlice({
    name: "devicesHistory",
    initialState,
    reducers: {
        setDeviceHistoryList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            deviceHistoryList: action.payload,
        }),
        setLoaderList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            listLoading: action.payload,
        }),
        setLoaderAdd: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            addLoading: action.payload,
        }),
        setDeviceVersionList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
          ...state,
          deviceVersionList: action.payload,
      }),
    }
    
  })

export const { setDeviceHistoryList,setLoaderList,setDeviceVersionList,setLoaderAdd} = deviceHistorySlice.actions;

export default deviceHistorySlice.reducer;